<!-- 课程设置 -->
<template>
  <div>
    <div class="course_SetUp">
      <el-button
        type="primary"
        size="small"
        v-if="tag != 1"
        @click="addMuen()"
        icon="el-icon-plus"
        >新增章目录</el-button
      >
      <el-button
        type="warning"
        size="small"
        @click="toggleRowExpansion(true)"
        icon="el-icon-arrow-down"
        style="background-color:#FFBA00;"
        >全部展开</el-button
      >
      <el-button
        type="danger"
        size="small"
        @click="toggleRowExpansion(false)"
        icon="el-icon-arrow-up"
        style="background-color: #FF2D2D;"
        >全部折叠</el-button
      >
      <el-button
        v-if="tableData.length <= 0 && tag != 1"
        type="primary"
        size="small"
        @click="importInfo"
        icon="el-icon-upload"
        >系统导入</el-button
      >
      <el-button
        type="danger"
        v-if="tag != 1"
        style="float: right;"
        size="small"
        icon="el-icon-refresh"
        @click="refreshInfo"
        >重置</el-button
      >
      <el-row class="mt20">
        <el-table
          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="teacherOpenCourseMergeCourseInfoId"
          border
          lazy
          ref="dataTreeList"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren1' }"
        >
          <!-- <el-table-column prop="courseInfoName" label="目录名称" sortable></el-table-column> -->
          <el-table-column
            prop="courseInfoNo"
            width="200"
            label="序号"
            sortable
          ></el-table-column>
          <el-table-column prop="courseInfoName" label="目录名称" sortable>
            <template v-slot="scope">
              <template v-if="scope.row.courseInfoType == 2">
                <p class="m0" style="padding-left: 20px;">
                  {{ scope.row.courseInfoName }}
                </p>
              </template>
              <template v-if="scope.row.courseInfoType == 3">
                <p class="m0" style="padding-left: 40px;">
                  {{ scope.row.courseInfoName }}
                </p>
              </template>
              <template v-if="scope.row.courseInfoType == 4">
                <p class="m0" style="padding-left: 60px;">
                  {{ scope.row.courseInfoName }}
                </p>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="资源类型"
            header-align="center"
            align="left"
            sortable
            width="180"
          >
            <template v-slot="scope">
              <!-- 1	视频 2	PPT 3	PDF 4	链接 5	图文 -->
              <template v-if="scope.row.resourcesInfoType == 1">
                <el-image class="setUp_img" :src="video_img"></el-image>
                <p class="m0">视频</p>
              </template>
              <template v-if="scope.row.resourcesInfoType == 2">
                <template
                  v-if="$matchType(scope.row.resourcesInfoContent) == 'word'"
                >
                  <el-image class="setUp_img" :src="word_img"></el-image>
                  <p class="m0">word</p>
                </template>
                <template
                  v-if="$matchType(scope.row.resourcesInfoContent) == 'ppt'"
                >
                  <el-image class="setUp_img" :src="ppt_img"></el-image>
                  <p class="m0">PPT</p>
                </template>
                <template
                  v-if="$matchType(scope.row.resourcesInfoContent) == 'pdf'"
                >
                  <el-image class="setUp_img" :src="pdf_img"></el-image>
                  <p class="m0">PDF</p>
                </template>
              </template>
              <template v-if="scope.row.resourcesInfoType == 3">
                <el-image class="setUp_img" :src="pdf_img"></el-image>
                <p class="m0">PDF</p>
              </template>
              <template v-if="scope.row.resourcesInfoType == 4">
                <el-image class="setUp_img" :src="link_img"></el-image>
                <p class="m0">链接</p>
              </template>
              <template v-if="scope.row.resourcesInfoType == 5">
                <el-image class="setUp_img" :src="img_img"></el-image>
                <p class="m0">图片</p>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <!-- 章节的操作 -->
              <template v-if="scope.row.courseInfoType == 2 && tag != 1">
                <el-button @click="addMuen(scope.row)" type="text" size="small"
                  >添加子章节</el-button
                >
                <el-button type="text" size="small" @click="editMuen(scope.row)"
                  >编辑</el-button
                >
                <el-button type="text" size="small" @click="delInfo(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="moveInfo_zj('MOVE_LEFT', scope.row)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="moveInfo_zj('MOVE_RIGHT', scope.row)"
                  >下移</el-button
                >
              </template>
              <!-- 小节的操作 -->
              <template v-if="scope.row.courseInfoType == 3 && tag != 1">
                <el-dropdown
                  trigger="click"
                  @command="handleCommand"
                  style="margin-right: 10px;"
                >
                  <el-button class="el-dropdown-link" type="text" size="small"
                    >上传资源</el-button
                  >
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="{
                        type: 'a',
                        teacherOpenCourseMergeCourseInfoId:
                          scope.row.teacherOpenCourseMergeCourseInfoId
                      }"
                      >本地上传</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="{
                        type: 'b',
                        teacherOpenCourseMergeCourseInfoId:
                          scope.row.teacherOpenCourseMergeCourseInfoId
                      }"
                      >资源库上传</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button
                  class="el-dropdown-link"
                  type="text"
                  size="small"
                  @click="addLink(scope.row)"
                  >添加链接</el-button
                >
                <el-button
                  class="el-dropdown-link"
                  type="text"
                  size="small"
                  @click="addImg(scope.row)"
                  >添加图文</el-button
                >
                <el-button type="text" size="small" @click="editMuen(scope.row)"
                  >编辑</el-button
                >
                <el-button type="text" size="small" @click="delInfo(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="moveInfo_zj('MOVE_LEFT', scope.row)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="moveInfo_zj('MOVE_RIGHT', scope.row)"
                  >下移</el-button
                >
              </template>
              <!-- 资源的操作 -->
              <template v-if="scope.row.courseInfoType == 4">
                <el-button @click="look(scope.row)" type="text" size="small"
                  >查看</el-button
                >
                <template v-if="tag != 1">
                  <el-button
                    type="text"
                    size="small"
                    @click="editMuen(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="delInfo(scope.row)"
                    >删除</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="moveInfo('MOVE_LEFT', scope.row)"
                    >上移</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="moveInfo('MOVE_RIGHT', scope.row)"
                    >下移</el-button
                  >
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>

    <!-- 系统导入 -->
    <el-dialog title="导入课程设计" :visible.sync="importShow" width="500px">
      <span slot="title">
        <i
          class="el-icon-s-check"
          style="margin-right: 10px;color: #67C23A;"
        ></i
        >导入课程设计
      </span>
      <el-select
        clearable
        style="width: 100%;margin-bottom: 20px;"
        v-model="importId"
        placeholder="请选择课程名称"
      >
        <template v-for="(item, index) in courseImportList">
          <el-option
            :label="item.courseInfoName"
            :value="item.courseInfoId"
          ></el-option>
        </template>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importShow = false">取 消</el-button>
        <el-button type="primary" @click="submitImportShow">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 本地上传资料 -->
    <el-dialog title="本地上传" :visible.sync="uploadFileShow" width="800px">
      <el-input
        style="margin-bottom:10px;"
        v-model="uploadFile.resourcesInfoName"
        placeholder="请输入文件名称"
      ></el-input>
      <el-row>
        <el-col :span="12">
          <UploadFile
            ref="picture"
            :isPdf="true"
            v-if="uploadFileShow"
            @onSuccess="uploadFileSuccess"
          />
        </el-col>
        <el-col :span="12">
          <p>上传须知：</p>
          <p style="text-indent: 2em;">1、可上传视频格式：MP4</p>
          <p style="text-indent: 2em;">2、可上传文档包括：word、ppt、pdf</p>
          <p style="text-indent: 2em;">3、默认使用文件名称，可自行修改</p>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadFileShow = false">取 消</el-button>
        <el-button type="primary" @click="submitUploadFile">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 资源库上传 -->
    <el-dialog title="资源库上传" :visible.sync="uploadPoolShow" width="800px">
      <el-row>
        <el-row>
          <label>资源名称：</label>
          <el-input
            style="width: 200px;"
            v-model="poolSearch.name"
            placeholder="请输入资源名称"
          ></el-input>
          <label class="ml20">归属课程：</label>
          <el-select
            v-model="poolSearch.courseInfoId"
            placeholder="请选择归属课程"
          >
            <template v-for="(item, index) in courseImportList">
              <el-option
                :label="item.courseInfoName"
                :value="item.courseInfoId"
              ></el-option>
            </template>
          </el-select>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getPoolInfo((page = 1))"
            >搜索</el-button
          >
        </el-row>
        <el-table
          :data="tablePool"
          border
          style="width: 100%;margin-top: 10px;"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column
            prop="resourcesInfoName"
            header-align="center"
            align="center"
            label="资源名称"
          >
          </el-table-column>
          <el-table-column
            prop="courseInfoParentParentName"
            header-align="center"
            align="center"
            label="归属课程"
          >
          </el-table-column>
          <el-table-column
            prop="resourcesInfoType"
            header-align="center"
            align="center"
            label="资源类型"
          >
            <template slot-scope="scope">
              {{ $retRresourcesName(scope.row.resourcesInfoType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="user_"
            header-align="center"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="lookPoolInfo(scope.row)"
                >查看</el-link
              >
              <el-link
                type="primary"
                :underline="false"
                @click="selectPoolInfo(scope.row)"
                >选择</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          class="block"
          style="text-align: right;bottom: 0;width: 96%;margin: 20px;"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            background
            :hide-on-single-page="true"
            layout="sizes, prev, pager, next,jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row>
      <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="uploadPoolShow = false">取 消</el-button>
          <el-button type="primary" @click="submitUploadPool">确 定</el-button>
        </span> -->
    </el-dialog>

    <!-- 添加链接 -->
    <el-dialog title="添加链接" :visible.sync="linkShow" width="800px">
      <el-form ref="form" :model="linkForm" label-width="80px">
        <el-form-item label="链接名称">
          <el-input
            v-model="linkForm.resourcesInfoName"
            placeholder="请输入链接名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接地址">
          <el-input
            v-model="linkForm.resourcesInfoContent"
            placeholder="请输入链接地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkShow = false">取 消</el-button>
        <el-button type="primary" @click="submitLink">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 添加图文 -->
    <el-dialog title="添加图文" :visible.sync="imgShow" width="800px">
      <el-form ref="form" :model="imgForm" label-width="80px">
        <el-form-item label="图文名称">
          <el-input
            v-model="imgForm.resourcesInfoName"
            placeholder="请输入图文名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <RichText
            ref="richText"
            v-if="imgShow"
            v-model="imgForm.resourcesInfoContent"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgShow = false">取 消</el-button>
        <el-button type="primary" @click="submitImg">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RichText from "@/components/RichText/index";
import UploadFile from "@/components/UploadFile"; //上传图片
export default {
  name: "SetUp",
  props: {
    courseId: {
      //课程ID
      type: String,
      required: true
    },
    tag: {
      //来源
      type: String,
      required: null
    }
  },
  components: {
    UploadFile,
    RichText
  },
  data() {
    return {
      ppt_img: require("../../../images/course/ppt@2x.png"),
      word_img: require("../../../images/course/word@2x.png"),
      pdf_img: require("../../../images/course/pdf@2x.png"),
      video_img: require("../../../images/course/shipinwenjian@2x.png"),
      link_img: require("../../../images/course/link@2x.png"),
      img_img: require("../../../images/course/tupian@2x.png"),
      tableData: [],
      importShow: false,
      importId: "",
      courseImportList: [],
      onCourseInfoId: "", //当前操作的章节ID
      uploadPoolShow: false,
      poolSearch: {
        courseInfoId: null,
        name: null
      },
      tablePool: [],

      total: 0,
      limit: 10,
      page: 1,
      linkShow: false,
      linkForm: {},
      imgShow: false,
      imgForm: {},
      uploadFileShow: false,
      uploadFile: {
        resourcesInfoContent: "", //文件地址
        resourcesInfoName: ""
      }
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getPoolInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getPoolInfo();
    },
    toggleRowExpansion(isExpansion) {
      this.toggleRowExpansion_forAll(this.tableData, isExpansion);
    },
    toggleRowExpansion_forAll(data, isExpansion) {
      data.forEach(item => {
        this.$refs.dataTreeList.toggleRowExpansion(item, isExpansion);
        if (item.children != undefined && item.children != null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      });
    },
    getInfo() {
      this.$post(
        "/api/teacherOpenCourseMergeCourseInfo/getTreeByTeacherOpenCourseId.do",
        { teacherOpenCourseId: this.courseId }
      ).then(ret => {
        if (ret.code == 0) {
          if (!this.$isEmpty(ret.data) && !this.$isEmpty(ret.data.children)) {
            this.tableData = ret.data.children;
            for (let item in this.tableData) {
              //处理resourcesInfo[] 资源数据匹配入
              this.tableData[item].courseInfoNo = this.$numberfilter(
                Number(item) + 1
              );
              for (let it in this.tableData[item].children) {
                this.tableData[item].children[it].courseInfoNo = Number(it) + 1;
                this.tableData[item].children[it].children = this.tableData[
                  item
                ].children[it].resourcesInfo;
                for (let i in this.tableData[item].children[it].children) {
                  //this.tableData[item].children[it].children[i].courseInfoNo = Number(item) + 1 +'.' + (Number(it) + 1)+'.' + (Number(i) + 1);
                  this.tableData[item].children[it].children[
                    i
                  ].courseInfoType = 4;
                  this.tableData[item].children[it].children[
                    i
                  ].courseInfoName = this.tableData[item].children[it].children[
                    i
                  ].resourcesInfoName;
                  this.tableData[item].children[it].children[
                    i
                  ].teacherOpenCourseMergeCourseInfoId =
                    this.tableData[item].children[it].children[i]
                      .teacherOpenCourseMergeCourseInfoId +
                    this.tableData[item].children[it].children[i]
                      .teacherOpenCourseMergeResourcesInfoId;
                }
              }
            }
          } else {
            this.tableData = [];
          }
        }
      });
    },
    look(item) {
      //查看课件
      if (item.resourcesInfoType == 4) {
        window.open(
          item.resourcesInfoContent.indexOf("http") == 0
            ? item.resourcesInfoContent
            : "http://" + item.resourcesInfoContent
        );
      } else {
        this.$router.push({
          name: "CoursewareViewing",
          query: {
            courseId: this.courseId,
            onId: item.teacherOpenCourseMergeCourseInfoId
          }
        });
      }
    },
    importInfo() {
      //系统导入课程设计
      this.importId = "";
      this.importShow = true;
      this.courseInfoPageByUniColleges();
    },
    courseInfoPageByUniColleges(typeInfo) {
      //获取归属课程
      if (this.courseImportList.length > 0) {
        //为空时在调用，避免每次都调用占用资源
        return;
      }
      // this.$post("/api/courseInfo/courseInfoPageByUniCollegesId.do").then((ret) =>{
      //courseType  0（开课课程）1（授权课程）
      this.$get(
        "/jlw/universitiesCollegesJurisdictionCurriculumResources/getTheoryAddOpenCourseList.json?teacherOpenCourseId=" +
          this.courseId +
          "&courseType=1"
      ).then(ret => {
        if (ret.code == 0) {
          this.courseImportList = ret.data;
          if (typeInfo == 1 && this.courseImportList.length > 0) {
            this.poolSearch.courseInfoId = this.courseImportList[0].courseInfoId;
            this.getPoolInfo();
          }
        }
      });
    },
    submitImportShow() {
      //提交导入
      if (this.$isEmpty(this.importId)) {
        this.$message({ message: "请选择需要导入的课程！", type: "warning" });
        return;
      }
      let proNum = this.courseImportList.findIndex((item, index) => {
        return item.courseInfoId == this.importId;
      });
      let courseType = this.courseImportList[proNum].courseType;
      const param = {
        teacherOpenCourseId: this.courseId,
        courseInfoIds: this.importId,
        courseType: courseType
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$post(
        "/api/teacherOpenCourseMergeCourseInfo/importCourseInfo.do",
        param
      )
        .then(ret => {
          loading.close();
          if (ret.code == 0) {
            this.getInfo();
            this.importShow = false;
            this.$message({ message: "导入成功！", type: "success" });
          } else {
            this.$message({ message: ret.msg, type: "error" });
          }
        })
        .catch(e => {
          loading.close();
        });
    },
    addMuen(item) {
      //新增章节目录
      this.$prompt("请输入章节名称", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "章节名称不能为空"
      })
        .then(({ value }) => {
          let param = {
            courseInfoName: value,
            teacherOpenCourseId: this.courseId,
            courseInfoType: 2
          };
          if (!this.$isEmpty(item)) {
            param.courseInfoParentId = item.teacherOpenCourseMergeCourseInfoId;
            param.courseInfoType = 3;
            param.courseLabelId = item.courseLabelId;
          } else {
            if (this.tableData == null || this.tableData.length <= 0) {
              // param.courseInfoParentId = 0;
            } else {
              param.courseInfoParentId = this.tableData[0].courseInfoParentId;
            }
          }
          this.submitAdd(param);
        })
        .catch(e => {
          console.log(e);
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    editMuen(item) {
      //编辑章节目录
      if (item.courseInfoType == 4) {
        //资源编辑
        this.onCourseInfoId = item.teacherOpenCourseMergeCourseInfoId;
        if (item.resourcesInfoType == 4) {
          //1	视频 2	PPT 3	PDF 4	链接 5	图文
          this.linkForm = item;
          this.linkShow = true;
        } else if (item.resourcesInfoType == 5) {
          this.imgForm = item;
          this.imgShow = true;
        } else {
          this.uploadFile = Object.assign({}, item);
          this.uploadFileShow = true;
          let this_ = this;
          setTimeout(function() {
            this_.$refs.picture.imageUrl =
              this_.uploadFile.resourcesInfoContent;
          }, 10);
        }
      } else {
        this.$prompt("请输入章节名称", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue: !this.$isEmpty(item) ? item.courseInfoName : null,
          inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: "章节名称不能为空"
        })
          .then(({ value }) => {
            let param = {
              courseInfoName: value,
              teacherOpenCourseMergeCourseInfoId:
                item.teacherOpenCourseMergeCourseInfoId
            };
            this.$post(
              "/jlw/teacherOpenCourseMergeCourseInfo/edit.json",
              param
            ).then(ret => {
              if (ret.code == 0) {
                this.getInfo();
                this.$message({ message: "提交成功！", type: "success" });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
          });
      }
    },
    submitAdd(param) {
      //新增章节目录提交
      this.$post("/jlw/teacherOpenCourseMergeCourseInfo/add.json", param).then(
        ret => {
          if (ret.code == 0) {
            this.getInfo();
            this.$message({ message: "添加成功！", type: "success" });
          }
        }
      );
    },
    delInfo(item) {
      this.$confirm("是否确定删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = "/jlw/teacherOpenCourseMergeCourseInfo/delete.json"; //章节删除
          let param = { ids: item.teacherOpenCourseMergeCourseInfoId };
          if (item.courseInfoType == 4) {
            param.ids = item.teacherOpenCourseMergeResourcesInfoId;
            url = "/jlw/teacherOpenCourseMergeResourcesInfo/delete.json"; //资源删除
          }
          this.$post(url, param).then(ret => {
            if (ret.code == 0) {
              this.getInfo();
              this.$message({ message: "删除成功！", type: "success" });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleCommand(command) {
      //上传类型选择
      if (command.type == "a") {
        //本地上传
        this.uploadFile.resourcesInfoContent = "";
        this.uploadFile.resourcesInfoName = "";
        this.uploadFileShow = true;
        let this_ = this;
        // setTimeout(function(){
        //   this_.$refs.picture.imageUrl = "this_.uploadFile.resourcesInfoContent";
        // },10);
      } else if (command.type == "b") {
        //资源库上传
        this.uploadPoolShow = true;
        this.courseInfoPageByUniColleges(1);
      }
      this.onCourseInfoId = command.teacherOpenCourseMergeCourseInfoId; //当前操作的章节ID
    },
    submitUploadFile() {
      //提交本地上传资料信息
      if (this.$isEmpty(this.uploadFile.resourcesInfoName)) {
        this.$message({ message: "请输入文件名称！", type: "warning" });
        return;
      }
      if (this.$isEmpty(this.uploadFile.resourcesInfoContent)) {
        this.$message({ message: "请上传文件！", type: "warning" });
        return;
      }
      this.uploadFile.teacherOpenCourseMergeCourseInfoId = this.onCourseInfoId;
      //1	视频 2	PPT 3	PDF 4	链接 5	图文
      let type = this.$matchType(this.uploadFile.resourcesInfoContent); //文件类型
      let resourcesInfoType = 0;
      if (type == "word" || type == "ppt") {
        resourcesInfoType = 2;
      } else if (type == "pdf") {
        resourcesInfoType = 3;
      } else if (type == "video") {
        resourcesInfoType = 1;
      }
      if (resourcesInfoType <= 0) {
        this.$message({
          message: "文件类型错误，请重新上传！",
          type: "warning"
        });
        return;
      }
      this.uploadFile.resourcesInfoType = resourcesInfoType;
      this.uploadFile.teacherOpenCourseId = this.courseId;
      this.submitResourcesInfo(this.uploadFile);
    },
    uploadFileSuccess(ret) {
      if (!this.$isEmpty(ret.cvPDFUrl)) {
        this.uploadFile.resourcesInfoContent = ret.cvPDFUrl;
      } else {
        this.uploadFile.resourcesInfoContent = ret.url;
      }
      this.uploadFile.resourcesInfoName = ret.name;
    },
    submitUploadPool() {
      this.uploadPoolShow = false;
    },
    getPoolInfo() {
      //获取资源列表
      let param = {
        limit: this.limit,
        page: this.page,
        resourcesInfoName: this.poolSearch.name,
        courseInfoIds: this.poolSearch.courseInfoId
      };
      this.$post("/jlw/resourcesInfo/list.json", param).then(ret => {
        if (ret.code == 0) {
          this.total = Number(ret.count);
          this.tablePool = ret.data;
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    moveInfo(sign, item) {
      //sign 1:上移 2：下移
      this.$post("/jlw/teacherOpenCourseMergeResourcesInfo/move.json", {
        moveType: sign,
        id: item.teacherOpenCourseMergeResourcesInfoId
      }).then(ret => {
        if (ret.code == 0) {
          this.getInfo();
          this.$message({ message: "操作成功！", type: "success" });
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    moveInfo_zj(sign, item) {
      this.$post("/jlw/teacherOpenCourseMergeCourseInfo/move.json", {
        moveType: sign,
        id: item.teacherOpenCourseMergeCourseInfoId
      }).then(ret => {
        if (ret.code == 0) {
          this.getInfo();
          this.$message({ message: "操作成功！", type: "success" });
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    addLink(item) {
      this.linkForm = {};
      this.onCourseInfoId = item.teacherOpenCourseMergeCourseInfoId;
      this.linkShow = true;
    },
    submitLink() {
      //提交链接添加
      if (this.$isEmpty(this.linkForm.resourcesInfoName)) {
        this.$message({ message: "请输入链接名称！", type: "warning" });
        return;
      }
      if (this.$isEmpty(this.linkForm.resourcesInfoContent)) {
        this.$message({ message: "请输入链接地址！", type: "warning" });
        return;
      }
      this.linkForm.teacherOpenCourseMergeCourseInfoId = this.onCourseInfoId;
      //1	视频 2	PPT 3	PDF 4	链接 5	图文
      this.linkForm.resourcesInfoType = 4;
      this.linkForm.teacherOpenCourseId = this.courseId;
      this.submitResourcesInfo(this.linkForm);
    },
    addImg(item) {
      this.imgForm = {};
      this.onCourseInfoId = item.teacherOpenCourseMergeCourseInfoId;
      this.imgShow = true;
    },
    submitImg() {
      //图文提交
      if (this.$isEmpty(this.imgForm.resourcesInfoName)) {
        this.$message({ message: "请输入图文名称！", type: "warning" });
        return;
      }
      if (this.$isEmpty(this.imgForm.resourcesInfoContent)) {
        this.$message({ message: "请输入图文内容！", type: "warning" });
        return;
      }
      this.imgForm.teacherOpenCourseMergeCourseInfoId = this.onCourseInfoId;
      this.imgForm.teacherOpenCourseId = this.courseId;
      //1	视频 2	PPT 3	PDF 4	链接 5	图文
      this.imgForm.resourcesInfoType = 5;
      this.submitResourcesInfo(this.imgForm);
    },
    submitResourcesInfo(param) {
      // 提交资源数据
      let url = "/jlw/teacherOpenCourseMergeResourcesInfo/add.json";
      if (!this.$isEmpty(param.teacherOpenCourseMergeResourcesInfoId)) {
        param.teacherOpenCourseMergeCourseInfoId = ""; //由于这个值是被我们修改的  为了不影响所有将其置空
        url = "/jlw/teacherOpenCourseMergeResourcesInfo/edit.json";
      }
      this.$post(url, param).then(ret => {
        if (ret.code == 0) {
          this.uploadPoolShow = false;
          if (param.resourcesInfoType == 4) {
            this.linkShow = false;
          } else if (param.resourcesInfoType == 5) {
            this.imgShow = false;
            this.$refs.richText.content = ""; //清空编辑框
          } else {
            this.uploadFileShow = false;
          }
          this.getInfo();
          this.$message({ message: "提交成功！", type: "success" });
        } else {
          this.$message({ message: ret.msg, type: "error" });
        }
      });
    },
    refreshInfo() {
      //重置
      this.$confirm(
        "如果进行重置，您之前的操作将会被全部清除！是否继续重置?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$post(
            "/api/teacherOpenCourseMergeCourseInfo/deleteAllResourcesByTeacherOpenCourseId.do",
            { teacherOpenCourseId: this.courseId }
          ).then(ret => {
            if (ret.code == 0) {
              this.getInfo();
              this.$message({ message: "重置成功！", type: "success" });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    selectPoolInfo(item) {
      //确定选择资源库资源 //1	视频 2	PPT 3	PDF 4	链接 5	图文
      let param = {
        resourcesInfoName: item.resourcesInfoName,
        resourcesInfoContent: item.resourcesInfoContent,
        resourcesInfoFiles: item.resourcesInfoFiles,
        resourcesInfoType: item.resourcesInfoType,
        teacherOpenCourseMergeCourseInfoId: this.onCourseInfoId,
        teacherOpenCourseId: this.courseId
      };
      this.submitResourcesInfo(param);
    },
    lookPoolInfo(item) {
      //查看资源库资源
      if (item.resourcesInfoType == 4) {
        window.open(
          item.resourcesInfoContent.indexOf("http") == 0
            ? item.resourcesInfoContent
            : "http://" + item.resourcesInfoContent
        );
        return;
      } else {
        this.$ls.set(this.$getKeyInfo("TCoursewareViewingInfo"), item);
        this.$router.push({ name: "TCoursewareViewing" });
      }
    }
  }
};
</script>
<style lang="less">
.course_SetUp {
  .has-gutter th {
    background-color: #f9f9fa;
  }
  .setUp_img {
    width: 20px;
    float: left;
    margin-right: 10px;
    margin-left: 50px;
  }
  .el-table .el-table__cell {
    padding: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/SetUp.vue